var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "favorite-gallery" },
    [
      _vm._l(_vm.products, function(item) {
        return _c(
          "div",
          { key: item.id, staticClass: "favorite-gallery__item" },
          [
            _c("product-list-item", {
              attrs: { product: item, "favorite-size-selector": "" }
            })
          ],
          1
        )
      }),
      !_vm.isEnd
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "reached",
                  rawName: "v-reached",
                  value: _vm.onLoad,
                  expression: "onLoad"
                }
              ],
              staticClass: "favorite-gallery__loader"
            },
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.isLoading
                    ? _c("ui-loader", { attrs: { size: "60" } })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }